var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"padding":"30px"}},[_vm._v("Cashier View")])
}
var staticRenderFns = []

export { render, staticRenderFns }